import { useSearchParams } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { InquiryForm } from "../components/site/InquiryForm";
import { WhatsAppIcon } from "../components/site/WhatsAppIcon";
import { EMAIL, PHONE, PHONE_TEL, waLink } from "../lib/site";
import useSeo from "../lib/useSeo";

export default function Contact() {
  useSeo({ title: "Contact Us — Plan Your Trip | Wandervibe Journeys", description: "Plan your trip with Wandervibe Journeys. Email info@wandervibejourneys.in or call +91 8755211549.", path: "/contact-us" });
  const [sp] = useSearchParams();
  const defaults = { destination: sp.get("destination") || "", category: sp.get("category") || "" };
  return (
    <section className="container-x grid gap-12 py-16 md:py-24 lg:grid-cols-[1fr_1.2fr]">
      <div>
        <p className="eyebrow">Contact Us</p>
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl">Let's plan your next journey</h1>
        <p className="mt-5 max-w-md text-base text-slate-600 md:text-lg">Tell us where you want to go and our travel expert will get back to you.</p>
        <div className="mt-10 space-y-4 rounded-3xl border border-slate-200 bg-white p-7" data-testid="contact-details">
          <h2 className="font-display text-xl font-extrabold">Wandervibe Journeys</h2>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-sm hover:text-[#FD691B]" data-testid="contact-details-email"><Mail className="h-5 w-5 text-[#FD691B]" />Email: {EMAIL}</a>
          <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-3 text-sm hover:text-[#FD691B]" data-testid="contact-details-phone"><Phone className="h-5 w-5 text-[#FD691B]" />Phone: {PHONE}</a>
          <p className="flex items-center gap-3 text-sm"><MapPin className="h-5 w-5 text-[#FD691B]" />Uttarakhand, India</p>
          <a href={waLink()} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white" data-testid="contact-whatsapp-btn"><WhatsAppIcon />Chat on WhatsApp</a>
        </div>
      </div>
      <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-xl shadow-slate-200/60 md:p-10">
        <h2 className="text-xl sm:text-2xl">Plan My Trip</h2>
        <p className="mt-2 text-sm text-slate-500">Fields marked * are required.</p>
        <div className="mt-6"><InquiryForm variant="contact" defaults={defaults} idPrefix="contact" /></div>
      </div>
    </section>
  );
}
